
import { Component, Vue, Prop } from "vue-property-decorator";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";
import track from "@/lib/common/track";

// 面试链接
@Component({
  components: {
    ModalHeader
  }
})
export default class ExamLink extends Vue {
  /***
暂时废弃 暂时废弃 暂时废弃
*
*
*/
  @Prop({ type: String, default: "" }) link!: string;
  @Prop({ type: String, default: "" }) scanStr!: string;
  @Prop({ type: Number, default: 0 }) examId!: number;
  @Prop({ type: String, default: "" }) examName!: string;
  name = "modal-exam-link";
  modalTitle: ModalTitle = new ModalTitle();

  created() {
    this.modalTitle.title = "面试链接";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = "肯德基餐厅储备经理校招-WJW36";
  }

  copyLink() {
    // 神策埋点
    track("click_copy_link", {
      exam_id: this.examId,
      exam_name: this.examName,
      is_click: true,
      operation_type: "按钮点击",
      operation_name: "点击面试链接中复制链接按钮"
    });
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = this.link;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  downloadBarcode(fileName = "AI面试二维码") {
    // 神策埋点
    track("click_download_qr", {
      exam_id: this.examId,
      exam_name: this.examName,
      is_click: true,
      operation_type: "按钮点击",
      operation_name: "点击面试链接中保存二维码按钮"
    });
    const a = document.createElement("a");
    a.href = this.scanStr;
    a.setAttribute("download", fileName + ".jpeg");
    a.click();
  }
}
